var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _circle, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _path16, _path17, _path18, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 339.863H0v75.034a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828L512 339.863z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256.001H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 256.001z",
    fill: "#ffe15a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M0 256.001h512v83.86H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.788 260.954l64.48-55.268v79.987c0 13.481-10.929 24.408-24.408 24.408a24.413 24.413 0 0 1-16.329-6.265l-23.743-21.368v-21.494z",
    fill: "#ffe15a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.801 292.405l-18.66-16.794v-27.815l33.775-28.95v66.828c0 4.993-4.063 9.056-9.056 9.056a9.045 9.045 0 0 1-6.059-2.325z",
    fill: "#ff4b55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.352 239.901v31.617l15.352 13.862v-58.637l9.212-7.896v66.828c0 4.993-4.063 9.056-9.056 9.056a9.04 9.04 0 0 1-6.059-2.325l-18.66-16.794v-27.815l9.211-7.896z",
    fill: "#41479b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.212 260.954l-64.48-55.268v79.987c0 13.481 10.929 24.408 24.408 24.408 6.03 0 11.847-2.232 16.329-6.265l23.743-21.368v-21.494z",
    fill: "#ffe15a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.199 292.405l18.66-16.794v-27.815l-33.775-28.95v66.828c0 4.993 4.063 9.056 9.056 9.056a9.045 9.045 0 0 0 6.059-2.325z",
    fill: "#ff4b55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.648 239.901v31.617l-15.352 13.862v-58.637l-9.212-7.896v66.828c0 4.993 4.063 9.056 9.056 9.056a9.04 9.04 0 0 0 6.059-2.325l18.66-16.794v-27.815l-9.211-7.896zM309.04 205.961h4.414v26.449h-4.414zM198.51 205.961h4.414v26.449h-4.414z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5a4646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.788 193.405s6.141-29.17-15.352-25.332-21.493 9.978-46.057 22.261c0 0 27.634 6.141 39.916 3.071 0 0 9.212 12.281 18.423 15.352h9.212l-6.142-15.352zM265.212 193.405s-6.141-29.17 15.352-25.332c21.493 3.838 21.493 9.978 46.057 22.261 0 0-27.634 6.141-39.916 3.071 0 0-9.212 12.281-18.423 15.352h-9.212l6.142-15.352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.212 208.757h-18.423v-15.466a9.098 9.098 0 0 1 9.098-9.098h.227a9.098 9.098 0 0 1 9.098 9.098v15.466z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 193.401,
    r: 6.141,
    fill: "#e6e1cd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.823 189.439l11.546 6.166a2.494 2.494 0 0 0 2.937-3.964l-7.448-7.448h-1.791a5.245 5.245 0 0 0-5.244 5.246z",
    fill: "#ffd0af"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M246.827 190.334h-9.249l4.047-4.738a4.002 4.002 0 0 1 3.042-1.402h5.192v3.108a3.033 3.033 0 0 1-3.032 3.032z",
    fill: "#ffaf94"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#8cb400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.186 208.765c-2.072-2.458-2.514-5.717-1.504-8.541 2.954-.516 6.091.471 8.162 2.931 1.77 2.101 2.283 4.772 1.784 7.272a88.745 88.745 0 0 1 2.189 3.964c.041-.225.032-.448.096-.673.724-2.546 2.743-4.348 5.135-4.958 1.713 1.778 2.483 4.373 1.759 6.918-.622 2.19-2.228 3.777-4.18 4.581a86.865 86.865 0 0 1 2.247 5.69c.041-.118.044-.238.092-.355 1-2.451 3.206-4.019 5.65-4.362 1.506 1.955 1.986 4.619.987 7.07-.875 2.144-2.69 3.558-4.764 4.121 1.068 4.213 1.775 8.683 1.775 13.183h-3.071c0-3.922-.602-7.85-1.511-11.608-1.895.612-4.012.481-5.845-.641-2.236-1.37-3.416-3.778-3.361-6.223 2.154-1.16 4.835-1.203 7.071.168.081.049.135.121.213.173a83.574 83.574 0 0 0-2.077-5.365c-1.843.871-4.012 1.005-6.002.071-2.374-1.116-3.811-3.379-4.026-5.815 2.006-1.386 4.657-1.721 7.023-.62a88.6 88.6 0 0 0-2.206-4.002c-2.115-.244-4.152-1.218-5.636-2.979zM229.814 208.765c2.072-2.458 2.514-5.717 1.504-8.541-2.954-.516-6.091.471-8.162 2.931-1.77 2.101-2.283 4.772-1.784 7.272a88.745 88.745 0 0 0-2.189 3.964c-.041-.225-.032-.448-.096-.673-.724-2.546-2.743-4.348-5.135-4.958-1.713 1.778-2.483 4.373-1.759 6.918.622 2.19 2.228 3.777 4.18 4.581a86.865 86.865 0 0 0-2.247 5.69c-.041-.118-.044-.238-.092-.355-1-2.451-3.206-4.019-5.65-4.362-1.506 1.955-1.986 4.619-.986 7.07.875 2.144 2.69 3.558 4.764 4.121-1.068 4.213-1.775 8.683-1.775 13.183h3.071c0-3.922.602-7.85 1.511-11.608 1.895.612 4.012.481 5.845-.641 2.237-1.37 3.416-3.778 3.361-6.223-2.154-1.16-4.835-1.203-7.071.168-.081.049-.135.121-.213.173a83.574 83.574 0 0 1 2.077-5.365c1.843.871 4.012 1.005 6.002.071 2.374-1.116 3.811-3.379 4.026-5.815-2.006-1.386-4.657-1.721-7.023-.62a88.6 88.6 0 0 1 2.206-4.002c2.114-.244 4.151-1.218 5.635-2.979z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M256 276.307l-64.48-55.268v79.987c0 13.481 10.929 24.408 24.408 24.408 6.03 0 11.847-2.232 16.329-6.265L256 297.801v-21.494z",
    fill: "#ffe15a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.987 307.757l18.66-16.794v-27.815l-33.775-28.95v66.828c0 4.993 4.063 9.056 9.056 9.056a9.039 9.039 0 0 0 6.059-2.325z",
    fill: "#ff4b55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.436 255.253v31.617l-15.352 13.862v-58.637l-9.212-7.896v66.828c0 4.993 4.063 9.056 9.056 9.056a9.04 9.04 0 0 0 6.059-2.325l18.66-16.794v-27.815l-9.211-7.896z",
    fill: "#41479b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 276.307l64.48-55.268v79.987c0 13.481-10.929 24.408-24.408 24.408a24.413 24.413 0 0 1-16.329-6.265L256 297.801v-21.494z",
    fill: "#ffe15a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.013 307.757l-18.66-16.794v-27.815l33.775-28.95v66.828c0 4.993-4.063 9.056-9.056 9.056a9.037 9.037 0 0 1-6.059-2.325z",
    fill: "#ff4b55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.564 255.253v31.617l15.352 13.862v-58.637l9.212-7.896v66.828c0 4.993-4.063 9.056-9.056 9.056a9.04 9.04 0 0 1-6.059-2.325l-18.66-16.794v-27.815l9.211-7.896z",
    fill: "#41479b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 254.811,
    rx: 30.705,
    ry: 46.06,
    fill: "#69c3ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.366 267.096h55.268l3.071-12.281-13.993 2.333a9.617 9.617 0 0 1-7.839-2.184l-15.884-13.615a7.83 7.83 0 0 0-10.635.408l-9.988 9.988v15.351z",
    fill: "#009b64"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.087 252.751l5.274-3.37-9.374-8.034a7.83 7.83 0 0 0-10.635.408l-9.988 9.988v3.071l15.352-3.071 2.714 1.357a6.753 6.753 0 0 0 6.657-.349z",
    fill: "#f5f5f5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5aa0e6",
    d: "M228.366 267.096l3.07 18.422 15.352 15.353H256l12.281-3.07 12.283-12.283 3.07-18.422z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256 303.941c-18.624 0-33.775-22.039-33.775-49.128s15.151-49.128 33.775-49.128 33.775 22.039 33.775 49.128-15.151 49.128-33.775 49.128zm0-92.113c-15.236 0-27.634 19.284-27.634 42.987s12.397 42.987 27.634 42.987 27.634-19.284 27.634-42.987-12.398-42.987-27.634-42.987z",
    fill: "#ffc88c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#e1e1e1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.339 300.595c-2.574-3.554-6.406-5.865-10.746-5.865s-8.172 2.311-10.746 5.865c4.39 1.217 7.982 4.781 9.683 9.479a18.053 18.053 0 0 1 1.064 6.15c-.001-7.596 4.588-13.922 10.745-15.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.031 310.282s-.239 4.094-2.339 6.013l-.088-.072c-2.099-1.919-2.339-6.013-2.339-6.013l4.766.072z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.4 311.617h-76.8a1.516 1.516 0 0 1-1.516-1.516v-.038c0-.838.679-1.516 1.516-1.516h76.8c.838 0 1.516.679 1.516 1.516v.038c0 .837-.678 1.516-1.516 1.516z",
    fill: "#966446"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M271.428 316.223h-30.856a6.066 6.066 0 0 1-6.066-6.066v-.151a6.066 6.066 0 0 1 6.066-6.066h30.856a6.066 6.066 0 0 1 6.066 6.066v.151a6.067 6.067 0 0 1-6.066 6.066z",
    fill: "#be915a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.366 308.547H217.62a1.535 1.535 0 0 0 0 3.07h10.746v-3.07z",
    fill: "#b9b9b9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M256 316.223v28.054l-12.281-3.49 6.14-24.564z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M252.929 316.223l-6.141 21.494-12.281-3.071 9.212-18.423z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M240.648 316.223l-9.212 12.282 9.212 3.07 6.14-15.352z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M256 316.223v28.054l12.281-3.49-6.14-24.564z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M259.071 316.223l6.141 21.494 12.281-3.071-9.212-18.423z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M271.352 316.223l9.212 12.282-9.212 3.07-6.14-15.352z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.728 247.483l-4.414-4.448v-21.999h4.414zM322.646 243.035l-4.414 4.448v-26.447h4.414z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.38dbee5bd7ea7fff668cbe82e41ffbba.svg";
export { ForwardRef as ReactComponent };